import React from "react";
import { PageHeader } from "@/components/Shared";
import LessonCalendar from "@/components/LessonCalendar";

export default function CalendarPage() {
  return (
    <div>
      <PageHeader title="Calendario" subtitle="Lezioni dei corsi programmati, in svolgimento e conclusi." />
      <LessonCalendar />
    </div>
  );
}
